/**
 *
 * @module retryPolicy
 *
 */

import Check from 'check-types';
import Logging from './../../logging/entry';
import Exception from './../exception/entry';

const InvalidArgumentException = Exception.InvalidArgumentException;

const {
    instanceStrict
} = Check.assert;

/**
 *
 * @class RetryPolicy
 * @desc Provides service retry rules.
 *
 */
export default class RetryPolicy {

    /**
     *
     * @param {Number} retryBasePeriod
     * @param {Number} retryMultiplier
     * @param {Number} retryMaxAttempts
     * @param {Number} retryMaxPeriod
     * @param {SDK.Logging.Logger} [logger=Logging]
     *
     */
    constructor(retryBasePeriod, retryMultiplier, retryMaxAttempts, retryMaxPeriod, logger = Logging) {

        const errorMessage = {
            ctor: 'RetryPolicy(retryBasePeriod, retryMultiplier, retryMaxAttempts, retryMaxPeriod, logger)',
            get retryBasePeriod() {
                return `${this.ctor} retryBasePeriod should be a Number`;
            },
            get retryMultiplier() {
                return `${this.ctor} retryMultiplier should be a Number`;
            },
            get retryMaxAttempts() {
                return `${this.ctor} retryMaxAttempts should be a Numberr`;
            },
            get retryMaxPeriod() {
                return `${this.ctor} retryMaxPeriod should be a Number`;
            },
            get logger() {
                return `${this.ctor} needs SDK.Services.Logger instance.`;
            }
        };

        instanceStrict(logger, Logging.Logger, errorMessage.logger, InvalidArgumentException);

        if (Check.not.number(retryBasePeriod)) {
            logger.warn(RetryPolicy.name, errorMessage.retryBasePeriod);
        }

        if (Check.not.number(retryMultiplier)) {
            logger.warn(RetryPolicy.name, errorMessage.retryMultiplier);
        }

        if (Check.not.number(retryMaxAttempts)) {
            logger.warn(RetryPolicy.name, errorMessage.retryMaxAttempts);
        }

        if (Check.not.number(retryMaxPeriod)) {
            logger.warn(RetryPolicy.name, errorMessage.retryMaxPeriod);
        }

        /**
         *
         * @access public
         * @type {Number}
         * @desc Gets or sets the retry base period for activation in seconds.
         *
         */
        this.retryBasePeriod = retryBasePeriod;

        /**
         *
         * @access public
         * @type {Number}
         * @desc Gets or sets the retry multiplier for activation.
         *
         */
        this.retryMultiplier = retryMultiplier;

        /**
         *
         * @access public
         * @type {Number}
         * @desc Gets or sets the maximum number of retry attempts for activation.
         *
         */
        this.retryMaxAttempts = retryMaxAttempts;

        /**
         *
         * @access public
         * @type {Number}
         * @desc Gets or sets the maximum period for retry attempts for activation.
         *
         */
        this.retryMaxPeriod = retryMaxPeriod;

    }

}



// WEBPACK FOOTER //
// ./src/services/configuration/retryPolicy.js